/**
 * External links surfaced by the landing page. Update these in one place
 * rather than digging through component markup.
 *
 * Android `applicationId` and iOS bundle id are both `ly.dinarpulse.app`.
 * TODO: replace the App Store id (`idREPLACE_ME`) with the numeric id Apple
 * assigns once the iOS build is approved. Until then the badge opens the
 * App Store search by bundle id, which still resolves to the app.
 */
export const APP_IDS = {
  android: 'ly.dinarpulse.app',
  ios: 'ly.dinarpulse.app',
} as const;

export const STORE_URLS = {
  android: `https://play.google.com/store/apps/details?id=${APP_IDS.android}`,
  ios: 'https://apps.apple.com/app/idREPLACE_ME',
  telegram: 'https://t.me/dinarpulse',
} as const;

/** Hard-coded marketing copy for the app shell — version, name, credit. */
export const APP_META = {
  name: 'Dinar Pulse',
  tagline: 'Live Rates. Smarter Decisions.',
  version: '0.1.0',
  designedBy: 'Firas Gul',
} as const;
